import i18n from "../../../../i18n"
import QuantityInput from "./QuantityInput"

const ProductOptions = ({ product, selectedOptions, onOptionsChange }) => {

    if (!product.product_options || product.product_options.length === 0) {
        return null
    }

    // Units that should use checkboxes
    const checkboxUnits = ['pct', 'pc', 'f']
    // Units that should use quantity inputs
    const quantityUnits = ['u', 'kg', 'l', 'm', 'y', 'h']

    const handleOptionChange = (optionId, value, isCheckbox = false) => {
        if (isCheckbox) {
            onOptionsChange({
                ...selectedOptions,
                [optionId]: value
            })
        } else {
            // For quantity-based options, store the quantity (0 means not selected)
            onOptionsChange({
                ...selectedOptions,
                [optionId]: value
            })
        }
    }

    return (
        <div className="col-12 mt-3">
            <h6 className="mb-3">{i18n.t('Opties')}:</h6>
            <div className="row g-3">
                {product.product_options.map((option) => {
                    const unit = option.product_object?.unit
                    const useCheckbox = !unit || checkboxUnits.includes(unit)
                    const useQuantity = unit && quantityUnits.includes(unit)
                    
                    const optionValue = selectedOptions[option.id] || (useCheckbox ? false : 0)
                    const isSelected = useCheckbox ? optionValue : optionValue > 0
                    const optionName = option.product_object?.name || option.test || `Option ${option.id}`
                    const optionDescription = option.product_object?.short_description || ''
                    const optionImage = option.product_object?.image_object?.image

                    return (
                        <div key={option.id} className="col-12 col-md-6 col-lg-4">
                            <div className={`card h-100 ${isSelected ? 'border-primary' : ''}`} style={{ transition: 'all 0.2s' }}>
                                {/* Image */}
                                {optionImage && (
                                    <div className="card-img-top" style={{ height: '150px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa' }}>
                                        <img 
                                            src={optionImage} 
                                            alt={optionName} 
                                            className="img-fluid" 
                                            style={{ objectFit: 'contain', maxHeight: '100%', maxWidth: '100%' }} 
                                        />
                                    </div>
                                )}
                                
                                <div className="card-body d-flex flex-column">
                                    {/* Name */}
                                    <h6 className="card-title mb-2">{optionName}</h6>
                                    
                                    {/* Short Description */}
                                    {optionDescription && (
                                        <p className="card-text small text-muted mb-3 flex-grow-1">
                                            {optionDescription}
                                        </p>
                                    )}
                                    
                                    {/* Quantity/Selector */}
                                    <div className="mt-auto">
                                        {useCheckbox ? (
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`option-${option.id}`}
                                                    name={`${product.id}_option_${option.id}`}
                                                    checked={isSelected}
                                                    onChange={(e) => {
                                                        handleOptionChange(option.id, e.target.checked, true)
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor={`option-${option.id}`}>
                                                    {i18n.t('Selecteren')}
                                                </label>
                                            </div>
                                        ) : useQuantity ? (
                                            <div className="d-flex flex-column gap-2">
                                                <label className="form-label small mb-0" htmlFor={`option-quantity-${option.id}`}>
                                                    {i18n.t('Aantal')}:
                                                </label>
                                                <QuantityInput
                                                    value={optionValue}
                                                    onChange={(newValue) => handleOptionChange(option.id, newValue, false)}
                                                    min={0}
                                                    name={`${product.id}_option_${option.id}`}
                                                    dataId={option.id}
                                                />
                                            </div>
                                        ) : (
                                            // Fallback to checkbox if unit is not recognized
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`option-${option.id}`}
                                                    name={`${product.id}_option_${option.id}`}
                                                    checked={isSelected}
                                                    onChange={(e) => {
                                                        handleOptionChange(option.id, e.target.checked, true)
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor={`option-${option.id}`}>
                                                    {i18n.t('Selecteren')}
                                                </label>
                                            </div>
                                        )}
                                        
                                        {/* Price Explanation */}
                                        {option.price > 0 && (
                                            <div className="mt-2 pt-2 border-top">
                                                <small className="text-muted d-block">
                                                    <strong>{option.calc_pricing_type_display}:</strong> {
                                                        (unit === 'pct' || unit === 'pc') 
                                                            ? `${(option.price * 100).toFixed(1)}%`
                                                            : `€${option.price}${useQuantity && unit ? ` / ${unit}` : ''}`
                                                    }
                                                </small>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ProductOptions

